import { Injectable } from '@angular/core';

export type SessionStorageKey =
  | 'userFrequency'
  | 'accountId'
  | 'okta'
  | 'authConfig'
  | 'userDetailsStorage'
  | 'postLoginRedirectUrl';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  setItem(key: SessionStorageKey, value: string) {
    sessionStorage.setItem(key, value);
  }

  getItem(key: SessionStorageKey) {
    return sessionStorage.getItem(key);
  }

  removeItem(key: SessionStorageKey) {
    sessionStorage.removeItem(key);
  }

  clear() {
    sessionStorage.clear();
  }
}
